import { useState, useEffect, useRef } from "react";
import FullCalendar from "@fullcalendar/react";
import AccountLayout from "../../blocs/AccountLayout";
import timeGridPlugin from "@fullcalendar/timegrid";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import frLocal from "@fullcalendar/core/locales/fr";
import CreateRdv from "../../components/rdvoffcanvas/CreateRdv";
import EditRdvStandart from "../../components/rdvoffcanvas/EditRdvStandart";
import ShowRdvStandart from "../../components/rdvoffcanvas/ShowRdvStandart";
import { fetchCalendarData } from "../../store/slices/rendezVousPrestaSlice";
import { useDispatch, useSelector } from "react-redux";
import ShowRdvManual from "../../components/rdvoffcanvas/ShowRdvManual";
import EditRdvManual from "../../components/rdvoffcanvas/EditRdvManual";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { formatTime, parseDateUTC, toFrenchTimeUTC } from "../../utils/utils";

export function Agenda() {
  const calendarRef = useRef(null);
  const isMobileInitial =
    typeof window !== "undefined" && window.innerWidth < 600;
  const [isMobile, setIsMobile] = useState(isMobileInitial);
  // const [currentView, setCurrentView] = useState(isMobileInitial ? "timeGridDay" : "timeGridWeek");
  const [currentView, setCurrentView] = useState(
    isMobileInitial ? "timeGridDay" : "timeGridDay"
  );

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 600);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const dispatch = useDispatch();
  const { calendarData, allEtablissementEquipes } = useSelector(
    (state) => state.rdvPresta
  );
  const [showAdd, setShowAdd] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  const [showedit, setShowedit] = useState(false);
  const [showEditManual, setShowEditManual] = useState(false);
  const [EditManual, setEditManual] = useState(false);
  const [startdte, setStartdte] = useState("");
  const [endDte, setEndDte] = useState("")
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [selectedEmployee, setSelectedEmployee] = useState("all");
  useEffect(() => {
    dispatch(fetchCalendarData());
  }, [dispatch]);
  dayjs.extend(utc);
  dayjs.extend(timezone);

  const AgendaRdv = calendarData?.appointments;
  const events = Array.isArray(AgendaRdv)
    ? AgendaRdv.map((rdv) => ({
        id: rdv?.id,
        title: rdv?.prestations_snapshot[0]?.name || rdv?.title,
        // start: rdv?.start_time,
        start: dayjs(rdv?.start_time).tz("Europe/Paris").format(),
        end: dayjs(rdv?.end_time).tz("Europe/Paris").format(),
        backgroundColor: getEventColor(rdv?.status, rdv?.type).backgroundColor,
        borderColor: getEventColor(rdv?.status, rdv?.type).borderColor,
        textColor: "#202020",
        extendedProps: { ...rdv },
      }))
    : [];
  const filteredEvents =
    selectedEmployee === "all"
      ? events
      : events.filter(
          (event) =>
            event.extendedProps.equipe_id === parseInt(selectedEmployee)
        );
  function getEventColor(status, type) {
    switch (type) {
      case "standard":
        if (status === "confirme") {
          return { backgroundColor: "#D5E3F9", borderColor: "#2D71E266" };
        } else if (status === "enattente") {
          return { backgroundColor: "#F6E5D6", borderColor: "#D17E3166" };
        } else {
          return { backgroundColor: "#808080", borderColor: "#808080" };
        }
      case "manual_user":
        return { backgroundColor: "#FFFFFF", borderColor: "#2D71E266" };
      case "unavailable":
        return { backgroundColor: "#E2E2E2", borderColor: "#17305A1A" };
      default:
        return { backgroundColor: "#E2E2E2", borderColor: "#17305A1A" };
    }
  }
  console.log("filteredEvents", filteredEvents);
  const handleShow = (start, end) => {
    setShowAdd(true);
    setStartdte(start);
    setEndDte(end);
  };
  const handleDrop = (info) => {
    console.log("info.event.start",info.event.start)
    const updatedEvent = {
      ...info.event.extendedProps,
      id: info.event.id,
      title: info.event.title,

      start_time:  dayjs(info.event.start).tz("Europe/Paris").format(),
      end_time: dayjs(info.event.end).tz("Europe/Paris").format(),

      // start_time: toFrenchTimeUTC(parseDateUTC(info?.event?.start)),
      // end_time: toFrenchTimeUTC(parseDateUTC(info?.info?.event?.end))
    };
   
    
    setSelectedEvent(updatedEvent);
    if (updatedEvent.type === "standard") setShowedit(true);
    else setEditManual(true);
  };
  const handleEventClick = (clickInfo) => {
    const selected = {
      ...clickInfo.event.extendedProps,
      id: clickInfo.event.id,
      title: clickInfo.event.title,
      start: clickInfo.event.start,
      end: clickInfo.event.end,
    };
    setSelectedEvent(selected);
    if (selected.type === "manual_user" || selected.type === "unavailable")
      setShowEditManual(true);
    else setShowDetails(true);
  };
  const handleViewChange = (e) => {
    const view = e.target.value;
    setCurrentView(view);
    if (calendarRef.current) {
      calendarRef.current.getApi().changeView(view);
    }
  };
  return (
    <AccountLayout bgColor={"bgColor"}>
      <div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "10px",
            flexWrap: "wrap",
          }}
        >
          <h3 style={{ margin: 0 }}>Agenda</h3>
          <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
            {isMobile && (
              <select
                value={currentView}
                onChange={handleViewChange}
                style={{
                  padding: "6px 12px",
                  borderRadius: "4px",
                  border: "1px solid #ccc",
                  fontSize: "14px",
                }}
              >
                <option value="timeGridDay">Jour</option>
                <option value="timeGridWeek">Semaine</option>
                <option value="dayGridMonth">Mois</option>
              </select>
            )}
            <select
              value={selectedEmployee}
              onChange={(e) => setSelectedEmployee(e.target.value)}
              style={{
                padding: "6px 12px",
                borderRadius: "4px",
                border: "1px solid #ccc",
                fontSize: "14px",
              }}
            >
              <option value="all">Tous les salariés</option>
              {allEtablissementEquipes?.map((emp) => (
                <option key={emp.id} value={emp.id}>
                  {emp.name}
                </option>
              ))}
            </select>
          </div>
        </div>
        <FullCalendar
          height="auto"
          ref={calendarRef}
          plugins={[timeGridPlugin, interactionPlugin, dayGridPlugin]}
          initialView={currentView}
          headerToolbar={
            isMobile
              ? {
                  left: "prev,next today",
                  center: "title",
                  right: "", // hide buttons on mobile
                }
              : {
                  left: "prev,next today",
                  center: "title",
                  right: "timeGridDay,timeGridWeek,dayGridMonth",
                }
          }
          locale={frLocal}
          weekends={true}
          events={filteredEvents}
          allDaySlot={false}
          firstDay={1}
          selectable={true}
          editable={true}
          eventClick={handleEventClick}
          select={(info) => handleShow(info.startStr, info.endStr)}
          eventDrop={handleDrop}
          slotMinTime="06:00:00"
          slotMaxTime="21:00:00"
          eventContent={renderEventContent}
          eventTimeFormat={{
            hour: "2-digit",
            minute: "2-digit",
            hour12: false,
          }}
        />
        <div className="d-flex flex-wrap align-items-center  mt-3">
          <Legend color="#D5E3F9" label="Rdv confirmé sur Twyny" />
          <Legend color="#F6E5D6" label="Rdv en attente de confirmation" />
          <Legend color="#808080" label="Rdv annulé" />
          <Legend color="#FFFFFF" border="#2D71E266" label="Rdv manuel" />
          <Legend color="#E2E2E2" label="Indisponible" />
        </div>
      </div>
      <CreateRdv
        show={showAdd}
        handleShow={handleShow}
        handleClose={() => setShowAdd(false)}
        placement={"end"}
        startdte={startdte}
        enddte={endDte}
      />
      <ShowRdvStandart
        show={showDetails}
        handleClose={() => setShowDetails(false)}
        event={selectedEvent}
        setShowedit={setShowedit}
      />
      {showEditManual && (
        <ShowRdvManual
          show={showEditManual}
          handleClose={() => setShowEditManual(false)}
          event={selectedEvent}
          setEditManual={setEditManual}
        />
      )}
      {EditManual && (
        <EditRdvManual
          show={EditManual}
          handleClose={() => setEditManual(false)}
          event={selectedEvent}
          startdte={startdte}
          enddte={endDte}
        />
      )}
      {showedit && (
        <EditRdvStandart
          show={showedit}
          handleClose={() => setShowedit(false)}
          event={selectedEvent}
        />
      )}
    </AccountLayout>
  );
}
function renderEventContent(eventInfo) {
  return (
    <div className="content_style">
      <span className="legend link">{eventInfo.event.title}</span>
      <p className="text-rdv legend grey-light">{eventInfo.timeText}</p>
    </div>
  );
}
function Legend({ color, border, label }) {
  return (
    <div className="d-flex align-items-center me-3">
      <span
        style={{
          width: 12,
          height: 12,
          borderRadius: "50%",
          backgroundColor: color,
          border: border ? `1px solid ${border}` : "none",
          display: "inline-block",
          marginRight: 6,
        }}
      ></span>
      <span className="legend">{label}</span>
    </div>
  );
}
export default Agenda;
